export default class Storage {
    static get(key, defaultValue = null) {
        const value = localStorage.getItem(key);
        return value === undefined || value === null ? defaultValue : value;
    }

    static set(key, value) {
        localStorage.setItem(key, value);
    }
}